import ImageTilesTemplate from './ImageTilesTemplate'

export * from './ImageTilesTemplate'

export default ImageTilesTemplate
